import { ref, shallowRef } from 'vue';

type SvgModules = Record<string, () => Promise<unknown>>;

export function useSvgComponent(
  modules: SvgModules,
  label: string,
  suffix: (name: string) => string,
) {
  const component = shallowRef<unknown>(null);
  const isLoading = ref(true);
  let loadId = 0;

  async function load(name: string): Promise<void> {
    loadId += 1;
    const currentLoadId = loadId;
    isLoading.value = true;

    const pathSuffix = suffix(name);
    const loader = Object.entries(modules).find(([path]) => path.endsWith(pathSuffix))?.[1];

    let loaded: unknown = null;
    if (!loader) {
      console.warn(`${label} "${name}" nicht gefunden`);
    } else {
      try {
        loaded = await loader();
      } catch (error) {
        console.error(`Fehler beim Laden von ${label} "${name}":`, error);
      }
    }

    // A slower load of a previous name must not replace the current component.
    if (currentLoadId !== loadId) return;
    component.value = loaded;
    isLoading.value = false;
  }

  return { component, isLoading, load };
}
